import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="border-t border-border bg-background text-muted" data-id="element-72" data-mp="3gezdb400vr15">
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-73" data-mp="3ghc0pwojutll">
        <p className="text-xs" data-id="element-74" data-mp="32p5m4f11ouo9">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}